import React, {useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';

import { Row, Col, Container, Card, CardBody, CardTitle } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

    const Timesheets = () => {
        const [step1, setStep1] = useState(true)
        const [step2, setStep2] = useState(false)
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Timesheets | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Timesheets" />
                        
                           
                        <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">&nbsp;</CardTitle>

                  <div className="hori-timeline">
                    <div
                      className="owl-carousel owl-theme  navs-carousel events"
                      id="timeline-carousel"
                    >

                    <div className="owl-nav" style={{ textAlign: "center" }}>
                      {step1 ? (
                        <>
                          <div
                            className="item event-list active"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                                
                                <h5 className="mb-4">Raise</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-send h1 text-primary down-arrow-icon" />
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  
                                <Link  to="/my-timesheets">
                                  Create Timesheets
                                </Link>
                                </p>
                              </div>
                            </div>
                          </div>

                          <div
                            className="item event-list"
                            style={{ display: "inline-table" }}
                          >
                            <div>
                              <div className="event-date">
                               
                                <h5 className="mb-4">Approval</h5>
                              </div>
                              <div className="event-down-icon">
                                <i className="bx bx-send h1 text-primary down-arrow-icon" />
                              </div>

                              <div className="mt-3 px-3">
                                <p className="text-muted">
                                  Submit Timesheets for Approval            
                                </p>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

                    </Container>
                </div>
            </>
        );
    }

export default Timesheets;